import React, { useEffect } from "react";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useTranslation } from "react-i18next";

import { IArrayLinkTabProps } from "./interface";
import { Container } from "./styles";

function samePageLinkNavigation(
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
) {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    event.shiftKey
  ) {
    return false;
  }
  return true;
}

/**
 *
 * @param  {{label: string | navigate: string }} menuList
 * @returns
 */
export const ButtonTabGroup = ({
  id,
  menuList,
  indexToSelect = 0,
  navigate,
}: IArrayLinkTabProps) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(indexToSelect);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (
      event.type !== "click" ||
      (event.type === "click" &&
        samePageLinkNavigation(
          event as React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        ))
    ) {
      setValue(newValue);
    }
  };

  useEffect(() => {
    setValue(indexToSelect);
  }, [indexToSelect]);

  return (
    <Container>
      <Box id={id} sx={{ width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{ hidden: true }}
          sx={{ padding: "0px", margin: "0px" }}
        >
          {menuList.map(
            (e, index) =>
              e.show && (
                <Tab
                  data-cy={t(e.label)}
                  key={index}
                  component="a"
                  onClick={(
                    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
                  ) => {
                    if (samePageLinkNavigation(event)) {
                      event.preventDefault();
                      if (value !== index) {
                        navigate(e.route);
                      }
                    }
                  }}
                  value={index}
                  label={t(e.label)}
                  sx={{ height: "5px" }}
                />
              ),
          )}
        </Tabs>
      </Box>
    </Container>
  );
};

export default ButtonTabGroup;
